// extracted by mini-css-extract-plugin
export default {"container":"otpTimeLeft_container__iVwZd","countdownText":"otpTimeLeft_countdownText__ol4k7"};